import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updatePageStatus } from 'redux/actions/ui.action';
import headerLogo from 'static/images/mvp/TECDlogoImage.png';
import {
  Box,
  Typography,
} from '@mui/material';
import CardPackage from './CardPackage';
// import { fetchUser, linkProvider, logInMvp, fetchUserMvp } from 'redux/actions/user.action';

import '../../custom-home.scss';
import './packages-payment.scss';

import Auth from '@aws-amplify/auth';

import { getSessions } from 'redux/actions/mvp/session.action';
import { getTecdPackages, getKatUSDTQuote } from 'redux/actions/mvp/tecd-package.action.js';

import { Row, Col } from 'antd';
import { I18n } from '../../../../../helpers/i18n';
class PackagesAndPayment extends React.Component {
  constructor() {
    super();

    this.state = {
      visibleMembershipModal: false,
      currentPage: 1,
      totalRecords: 0,
      pageLimit: 40,
      listSessions: [],
      packages: [],
    };
  }

  openMembershipModal = () => {
    if (!localStorage.getItem('popupModal') || localStorage.getItem('popupModal') === 'true') {
      this.setState({ visibleMembershipModal: true });
      localStorage.setItem('popupModal', 'true');
    }
  };

  async componentDidMount() {
    document.title = `TECD - ${I18n.t('tecd_slogan')}`;
    this.props.updatePageStatus('loading');
    const { getSessions, getTecdPackages, getKatUSDTQuote, getWalletSessionByUserId } = this.props;
    const sessions = await getSessions();
    const packages = await getTecdPackages();
    // const walletSession = await getWalletSessionByUserId(Auth.user.username);
    // console.log('packages:', packages.data.data);
    const katQuote = await getKatUSDTQuote();
    this.setState({ packages: packages.data.data });
    this.setState({ katQuote: katQuote.data.katToUSD });
    this.setState({ paxgQuote: katQuote.data.paxgToUSD });

    if (sessions.success) {
      const data = sessions.data.data;
      const listSessions = data.list;
      this.setState({
        listSessions,
        currentPage: data.currentPage,
        totalRecords: Number(data.total),
      });
    }
    this.props.updatePageStatus('loaded');
  }

  render() {
    const { totalRecords, pageLimit, listSessions, packages } = this.state;

    return (
      <div id="site_wrapper">
        <div className="site-upper">{this.props.header}</div>
        <main className="main-package-payment">
          <div className="container">
            <Box
              style={{
                width: '100%', // Fill width
                height: 'auto', // Hug content
                gap: '64px',
                alignItems: 'center',
                marginTop: '20px',
                marginBottom: '20px',
              }}
            >
              <div className="header-logo" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <img src={headerLogo} alt="Logo" style={{ height: '100px', width: '235.14px' }} />
              </div>
              <Typography variant="h1" className="section-title" style={{ marginTop: '20px', marginBottom: '20px' }}>
                {I18n.t('tecd_slogan_des')}
              </Typography>
              <ul className="list-horizontal">
                <li>{I18n.t('10_different')}</li>
                <li>{I18n.t('buddy_mentors')}</li>
                <li>{I18n.t('ai_support')}</li>
              </ul>
            </Box>

            <Box
              style={{
                width: '100%', // Fill width
                height: 'auto', // Hug content
                gap: '64px',
                alignItems: 'center',
                marginTop: '40px',
                marginBottom: '20px',
              }}
            >
              <Typography variant="h2" className="section-subtitle">
                {I18n.t('diverse_packages')}
              </Typography>

              <Row style={{ display: 'flex', justifyContent: 'center'}}>
                {this.state.packages &&
                  this.state.packages
                    .filter((pkg) => pkg.priceOrigin !== 0) // Lọc ra những pkg có priceOrigin khác 0
                    .map((pkg, index) => (
                      <CardPackage
                        key={index}
                        id={pkg.id}
                        title={pkg.title}
                        priceOrigin={pkg.priceOrigin}
                        priceKat={pkg.priceKat}
                        priceUsdt={pkg.priceUsdt}
                        totalSession={pkg.totalSession}
                        totalDay={pkg.totalDay}
                        packageMainColor={pkg.packageMainColor}
                        packageSubColor={pkg.packageSubColor}
                        saleOffPercentage={pkg.saleOffPercentage}
                        saleOffPercentageWithKATPayment={pkg.saleOffPercentageWithKATPayment}
                      />
                    ))}
              </Row>
            </Box>
          </div>
        </main>
        {this.props.footer}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  bounties: state.bounty,
  products: state.product,
  ui: state.ui,
  user: state.user,
  saleCampaigns: state.saleCampaign,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSessions,
      updatePageStatus,
      getTecdPackages,
      getKatUSDTQuote,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(PackagesAndPayment);
